import {AbstractControl, ValidationErrors, ValidatorFn, Validators} from '@angular/forms'
import {isBefore, isFuture, isToday, startOfToday} from 'date-fns'
import {userFriendlyParseDate} from './date.utils'

function isPresent(obj: unknown): boolean {
  return obj !== undefined && obj !== null
}

export const DateValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  if (isPresent(Validators.required(control))) {
    return null
  }

  return userFriendlyParseDate(control.value) === undefined ? {date: true} : null
}

export const DateInTheFutureValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  if (isPresent(Validators.required(control))) {
    return null
  }

  const date = userFriendlyParseDate(control.value)
  if (!date) {
    return {date: true}
  }

  if (!isFuture(date)) {
    return {dateInPast: true}
  }

  return null
}

export const DateInThePastValidator: (options: {allowToday: boolean}) => ValidatorFn =
  options =>
  (control: AbstractControl): ValidationErrors | null => {
    if (isPresent(Validators.required(control))) {
      return null
    }

    const date = userFriendlyParseDate(control.value)
    if (!date) {
      return {date: true}
    }

    if (options.allowToday && isToday(date)) {
      return null
    }

    const today = startOfToday()
    if (!isBefore(date, today)) {
      return {dateInFuture: true}
    }

    return null
  }

export const LocalDateTimeInTheFutureValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  if (isPresent(Validators.required(control))) {
    return null
  }

  const date = new Date(control.value)
  if (!date) {
    return {date: true}
  }

  if (!isFuture(date)) {
    return {dateInPast: true}
  }

  return null
}
